import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../app/store";
import type { ScenarioLibraryScenario } from "../models/scenarioLibraryScenario";

export interface ScenariosState {
    selectedScenarios: Record<string, ScenarioLibraryScenario | null>;
}

const initialState: ScenariosState = {
    selectedScenarios: {}
};

export const selectSelectedScenarios = (state: RootState) => state.scenarios.selectedScenarios;

const scenariosSlice = createSlice({
    name: "scenarios",
    initialState,
    reducers: {
        placeScenario: (state, action: PayloadAction<{ slotIndex: number; scenario: ScenarioLibraryScenario }>) => {
            const { slotIndex, scenario } = action.payload;

            Object.entries(state.selectedScenarios).forEach(([slot, selectedScenario]) => {
                if (selectedScenario?.id === scenario.id) {
                    delete state.selectedScenarios[slot];
                }
            });

            state.selectedScenarios[slotIndex] = scenario;
        },
        removeScenario: (state, action: PayloadAction<number>) => {
            delete state.selectedScenarios[action.payload];
        }
    }
});

export const { placeScenario, removeScenario } = scenariosSlice.actions;

export default scenariosSlice.reducer;
